import React from 'react';
import { Box, ThemeProvider } from '@mui/material';
import { PublicBrandProvider, usePublicBrandContext } from '../../context/PublicBrandContext';
import { brandPageSx } from '../../utils/publicBrand';

function PublicBrandShellInner({ children }) {
  const { theme, brand } = usePublicBrandContext();

  return (
    <ThemeProvider theme={theme}>
      <Box sx={brandPageSx(brand)}>{children}</Box>
    </ThemeProvider>
  );
}

/**
 * Loads tenant brand, applies MUI primary palette + page background.
 */
export default function PublicBrandShell({ children, embeddedBrand }) {
  return (
    <PublicBrandProvider embeddedBrand={embeddedBrand}>
      <PublicBrandShellInner>{children}</PublicBrandShellInner>
    </PublicBrandProvider>
  );
}
